import { render, staticRenderFns } from "./ResponsivePlayer.vue?vue&type=template&id=45c12430&scoped=true&"
import script from "./ResponsivePlayer.vue?vue&type=script&lang=js&"
export * from "./ResponsivePlayer.vue?vue&type=script&lang=js&"
import style0 from "./ResponsivePlayer.vue?vue&type=style&index=0&id=45c12430&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c12430",
  null
  
)

export default component.exports